module.exports = __webpack_public_path__ + "static/media/closeMenuMobile.ce7f188a.svg";